import React, { useMemo, memo } from "react";
import PropTypes from "prop-types";
import { cn } from "../../../Utils/helper";

const LoadingSlider = ({
  progress = 0,
  duration = null,
  className = "",
  barColor = "bg-[#253FF6]",
  trackColor = "bg-white",
}) => {
  const isDurationMode = !!duration;

  const progressStyle = useMemo(() => {
    if (isDurationMode) {
      return {
        width: "100%",
        animation: `slide-fill ${duration} linear forwards`,
      };
    }

    const isComplete = progress >= 100;
    return {
      width: `${Math.max(0, Math.min(100, progress))}%`,
      transition: isComplete ? "width 0.5s ease-out" : "width 0.1s linear",
    };
  }, [isDurationMode, duration, progress]);

  return (
    <div
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={isDurationMode ? undefined : progress}
      className={cn("relative flex items-center h-[5px] w-[120px]", className)}
    >
      <div
        className={cn(
          "absolute left-0 top-1/2 w-full h-[2.5px] -translate-y-1/2 rounded-full",
          trackColor
        )}
      />

      <div
        className={cn("relative z-10 h-full rounded-full", barColor)}
        style={progressStyle}
      />

      {isDurationMode && (
        <style>{`
          @keyframes slide-fill {
            from { width: 0%; }
            to { width: 100%; }
          }
        `}</style>
      )}
    </div>
  );
};

LoadingSlider.propTypes = {
  progress: PropTypes.number,
  duration: PropTypes.string,
  className: PropTypes.string,
  barColor: PropTypes.string,
  trackColor: PropTypes.string,
};

export default memo(LoadingSlider);
